export const CTA_MICRO_DISCLOSURE = {
  line1: "14-day free trial · No credit card",
  line2: "From $299/mo after trial · Cancel anytime",
};

export const CLOSING_CTA = {
  headline: {
    lead: "Ready to",
    accentPrimary: "Stop Losing $10,000+",
    leadMid: "Deals to Slow Callbacks?",
    accentSecondary: "",
  },
  subheadline:
    "Deploy your Digital Brain today and start capturing, qualifying, and booking leads in under 26 seconds.",
  buttonLabel: "Test On My Website Now",
};
